import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import PageNav from "../components/PageNav";
import styles from "./DocsLayout.module.css";

export default function DocsLayout() {
  const { pathname } = useLocation();
  const isWide = pathname.includes("/playground");

  return (
    <div className={styles.shell}>
      <Sidebar />
      <main className={styles.content}>
        <div className={isWide ? styles.articleWide : styles.article}>
          <Outlet />
          <PageNav />
        </div>
      </main>
    </div>
  );
}
